'use client';

import React, { useCallback, useRef } from 'react';
import { useOnViewport } from '@/components/core/hooks';
import clsx from 'clsx';
import * as styles from './result-grid.styles';
import { UIComponent } from '../..';

const ResultGrid: UIComponent<{
  hasMore?: boolean;
  onLoadMore?: () => any | Promise<any>;
  isLoading?: boolean;
  maxCols?: number;
  minCols?: number;
  itemClassName?: string;
}> = ({ isLoading, hasMore, onLoadMore, children, className, itemClassName, maxCols = 4, minCols = 1, ...props }) => {
  const ref = useRef(null);

  const onViewportCallback = useCallback(
    async (onViewport) => {
      if (onViewport) {
        await onLoadMore?.();
      }
    },
    [onLoadMore],
  );

  useOnViewport(ref, onViewportCallback, { disabled: isLoading || !hasMore });

  return (
    <ul style={{ '--col-size': maxCols, '--col-min': minCols } as React.CSSProperties} className={clsx(className, styles.grid)} {...props}>
      {React.Children.map(children, (item) => {
        return <li className={clsx(styles.cell, itemClassName)}>{item}</li>;
      })}
      <li className="-mt-1" ref={ref} />
    </ul>
  );
};

export default ResultGrid;
